// Number rules the game follows that JavaScript doesn't by default: Math.Round rounds half to even, `float` maths is 32-bit
// (Math.fround), and "0.#" formats round half away from zero.

/** Rounds half to even. */
export function roundHalfEven(x: number): number {
  const r = Math.round(x);
  return Math.abs(x % 1) === 0.5 && r % 2 !== 0 ? r - 1 : r;
}

export const f32 = Math.fround;

/** Vector2.DistanceSquared / Distance boundaries used by authoritative pixel reach checks. */
export function distanceSquaredF32(ax: number, ay: number, bx: number, by: number): number {
  const dx = f32(f32(ax) - f32(bx)), dy = f32(f32(ay) - f32(by));
  return f32(f32(dx * dx) + f32(dy * dy));
}
export const distanceF32 = (ax: number, ay: number, bx: number, by: number) =>
  f32(Math.sqrt(distanceSquaredF32(ax, ay, bx, by)));

/** The "0.#" format: at most one decimal, none when it would be 0. */
export function oneDecimal(x: number): string {
  const r = Math.sign(x) * Math.round(Math.abs(x) * 10) / 10;
  return Number.isInteger(r) ? String(r) : r.toFixed(1);
}

export const clamp = (v: number, min: number, max: number) => Math.min(max, Math.max(min, v));
